<template>
  <section
    :class="$style.root"
  >
    <div :class="$style.top">
      <h1 :class="$style.heading">{{ title }}</h1>
      <h2
        :class="$style.subtitle"
        v-if="subtitle || localizedData?.date"
      >
        {{ subtitle }}
        <CoreDateTimeRangeComponent
          :dateStart="localizedData?.date"
          :class="$style.date"
        />
      </h2>
    </div>

    <CoreImageSliderComponent
      v-if="localizedData?.images?.data"
      :images="localizedData?.images?.data"
    />

    <CoreTextComponent
      v-if="description"
      :string="description"
      :class="$style.text"
    />
  </section>
</template>

<script setup>
const props = defineProps({
  pageData: Object
})

const localizedData = computed(() => {
  return i18nGetLocalizedData(baseStrapiGetAttributes(props?.pageData?.data))
})

const title = computed(() => i18nGetLocalizedString(localizedData?.value?.titles))
const subtitle = computed(() => i18nGetLocalizedString(localizedData?.value?.subtitles))

const description = computed(() => i18nGetLocalizedString(localizedData?.value?.descriptions))
</script>

<style module>
.root {
  position: relative;

  display: flex;
  flex-direction: column;
  gap: calc(var(--unit--vertical) * 2);

  padding: 0 var(--unit--horizontal);
}

.top {
  margin-bottom: calc(var(--width--button--round) - var(--unit--vertical));

  composes: container--default from global;
  padding: 0;
}

.heading {
  composes: reset-heading font-size-large from global;
  text-align: center;
}

.subtitle {
  composes: reset-heading font-size-medium from global;
  text-align: center;
}

.date {
  composes: font-size-medium from global;
  text-align: center;
  display: block;
  color: var(--color--secondary);
}

.text {
  composes: container--default from global;
  padding: 0;
}
</style>
